import { apiGet, apiPost, authenticate } from "@redriver/cinnamon";

const NAMESPACE = "SYSTEM/LOGIN";
export const REQUEST_LOGIN = `${NAMESPACE}/REQUEST`;
export const REFRESH_JWT = `${NAMESPACE}/REFRESH_JWT`;
export const GET_SSO_CONFIG = `${NAMESPACE}/GET_SSO_CONFIG`;
export const CHECK_USES_MICROSOFT_SIGN_IN = `${NAMESPACE}/CHECK_USES_MICROSOFT_SIGN_IN`;
export const SEND_MAGIC_LINK = `${NAMESPACE}/SEND_MAGIC_LINK`;

// accounts that have switched to SSO no longer have a password credential and will fail
// with a generic "wrong password" (or silently no-op a magic link send) - check and point
// them at the Microsoft button if true, from either sign-in path
const checkUsesMicrosoftSignIn = (email) => async (dispatch) => {
  const checkAction = apiPost(
    CHECK_USES_MICROSOFT_SIGN_IN,
    "auth/uses-microsoft-sign-in",
    { email },
    { auth: false, preventErrorNotification: true }
  );
  const { success, response } = await dispatch(checkAction);
  return success && response === true;
};

export const requestLogin = ({ email, password }) => async (dispatch) => {
  if (await dispatch(checkUsesMicrosoftSignIn(email))) {
    return { success: true, response: { usesMicrosoftSignIn: true } };
  }

  // make the login api call
  const loginAction = apiPost(
    REQUEST_LOGIN,
    "auth/token/credentials",
    { key: email, secret: password },
    { auth: false, preventErrorNotification: true }
  );
  const result = await dispatch(loginAction);

  const { success, response } = result;
  if (success && response.tokens && !response.secondFactor) {
    // authenticate the user session - held back if a second accompanies the response,
    // even if tokens are already present, so the login flow routes through the authenticator page first
    const { access, refresh } = response.tokens;
    dispatch(authenticate(access, refresh));
  }

  return result;
};

export const requestMagicLink = ({ email }) => async (dispatch) => {
  if (await dispatch(checkUsesMicrosoftSignIn(email))) {
    return { success: true, response: { usesMicrosoftSignIn: true } };
  }

  const sendAction = apiPost(
    SEND_MAGIC_LINK,
    "auth/magic-link/send",
    { email },
    { auth: false, preventErrorNotification: true }
  );
  return dispatch(sendAction);
};

export const onRefreshJwt = (token) =>
  apiPost(
    REFRESH_JWT,
    "auth/token/refresh",
    { token },
    { auth: false, preventErrorNotification: true }
  );

export const getSsoConfig = () =>
  apiGet(GET_SSO_CONFIG, "sso/config", undefined, { auth: false });
